import script from "./list.vue?vue&type=script&lang=ts&setup=true"
export * from "./list.vue?vue&type=script&lang=ts&setup=true"

import "./list.scss?vue&type=style&index=0&id=01f6c0d2&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01f6c0d2"]])

export default __exports__